import type {
  IDefaultAPIResult,
  IDefaultAPIState,
} from 'types/state.interface';
import { type CreateFn, assertListWithIdElements, assertWithId } from './utils';

/**
 * standardized way of parsing a list API response into the redux state
 */
export function stateHasFetchedAllObjectsSuccess<
  P extends object,
  T extends object,
>(
  payload: IDefaultAPIResult<P>,
  state: IDefaultAPIState<T>,
  createFn: CreateFn<P, T>,
  retainNewEl = false
): void {
  const { results, page, limit, totalPages } = payload;
  const iteratedResults = results.map((el) => createFn(el));

  state.page = page;
  state.limit = limit;
  state.totalPages = totalPages;

  const newEl = state.map[0] || state.map['0'] || state.map['new'];

  if (retainNewEl && newEl) {
    state.results = [...iteratedResults, newEl];
  } else {
    state.results = iteratedResults;
  }

  if (!assertListWithIdElements(iteratedResults)) {
    return;
  }

  const map = iteratedResults.reduce(
    (tot, acc) => ({
      ...tot,
      [acc.id]: acc,
    }),
    {}
  );

  if (retainNewEl && assertWithId(newEl)) {
    state.map = {
      ...map,
      [newEl.id]: newEl,
    };
  } else {
    state.map = map;
  }
}
